import { SkuUserAgreementInfo } from "services/facultyPortalClient";
import StatusChip from "components/StatusChip";
import { UserAgreementStatusId } from "types/common-types";
import { useIntl } from "react-intl";

type SkuUserAgreementStatusChipProps = {
  skuUserAgreementInfo: SkuUserAgreementInfo;
};

type StatusConfig = {
  labelKey: string;
  color: "success" | "error";
};

const statusMap: Record<string, StatusConfig> = {
  [UserAgreementStatusId.Accepted.toLowerCase()]: {
    labelKey: "accepted",
    color: "success",
  },
  [UserAgreementStatusId.Pending.toLowerCase()]: {
    labelKey: "actionNeeded",
    color: "error",
  },
};

const SkuUserAgreementStatusChip = ({
  skuUserAgreementInfo,
}: SkuUserAgreementStatusChipProps) => {
  const { formatMessage: t } = useIntl();

  if (!skuUserAgreementInfo) {
    return null;
  }

  const key = skuUserAgreementInfo.statusId?.toLowerCase();
  const config = statusMap[key];

  if (!config) {
    return null;
  }

  return (
    <StatusChip label={t({ id: config.labelKey })} color={config.color} />
  );
};

export default SkuUserAgreementStatusChip;
